import React, { useEffect } from "react";

import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Header from "./components/header/Header";
import Footerr from "./components/footer/Footerr";
import Menu from "./components/menu/Menu";
import { EventEmitter } from "fbemitter";
import UserAPI from "./apis/UserAPI";
import HomePage from "./pages/home/HomePage";
import TermsPage from "./pages/terms/TermsPage";
import ArticlePage from "./pages/article/ArticlePage";
import SubCategoryPage from "./pages/subCategory/SubCategoryPage";
import CategoryPage from "./pages/category/CategoryPage";
import UnderSubCategoryPage from "./pages/underSubCategory/UnderSubCategoryPage";
import ContactUsPage from "./pages/contactUs/ContactUsPage";
import { AdministrationMenuPage } from "./pages/administration/AdministrationMenuPage";
import AboutPage from "./pages/about/AboutPage";
import SnackBar from "./components/snackbar/SnackBar";
import CartPage from "./pages/cart/CartPage";
import { LoginPage } from "./pages/login/LoginPage";
import MyAccountPage from "./pages/myAccount/MyAccountPage";
import ArticleEditPopup from "./components/article/editPopup/ArticleEditPopup";
import { AccountInfoPage } from "./pages/myAccount/accountInfo/AccountInfoPage";
import ScrollTop from "./components/scrollTop/ScrollTop";
import { SalesCampaignsPage } from "./pages/administration/overview/salesCampaigns/SalesCampaignsPage";
import { UsersManagementPage } from "./pages/administration/overview/usersManagement/UsersManagementPage";
import { OxygenePage } from "./pages/administration/overview/oxygene/OxygenePage";
import { HomeCatalogsPage } from "./pages/administration/overview/homeCatalogs/HomeCatalogsPage";
import CartValidatePage from "./pages/cartValidate/CartValidatePage";
import MyQuotesPage from "./pages/myAccount/quotes/MyQuotesPage";
import { RecoverPasswordPage } from "./pages/login/RecoverPasswordPage";
import QuotesPendingPage from "./pages/administration/overview/quotes/pending/QuotesPendingPage";
import QuotesOpenedPage from "./pages/administration/overview/quotes/opened/QuotesOpenedPage";
import QuotesHistoryPage from "./pages/administration/overview/quotes/history/QuotesHistoryPage";
import ArticleRedirect from "./pages/article/RedirectPage";
import InitializeGoogleAnalytics, { trackPageview } from "./GA";
import CategoryRedirect from "./pages/category/RedirectPage";
import SubCategoryRedirect from "./pages/subCategory/RedirectPage";
import UnderSubCategoryRedirect from "./pages/underSubCategory/RedirectPage";
import { URL_REDIRECT } from "./constant/url";
import NotFoundPage from "./pages/notFound/NotFoundPage";
import LegalNoticePage from "./pages/legalNotice/LegalNoticePage";
import { InitializeHotjar } from "./Hotjar";
import CookieConsentBanner from "./components/cookieConsent/CookieConsentBanner";
import { getConsent } from "./utils/consent";

function LocationWatcher() {
  const location = useLocation();

  useEffect((_) => {
    InitializeGoogleAnalytics();
  });

  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location]);

  return <div></div>;
}

export default class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.init();
  }

  init() {
    global.emitter = new EventEmitter();

    global.onArticleRightClicked = function (browserEvent, article) {
      browserEvent.preventDefault();
      if (UserAPI.isUserLoggedInAndAdmin()) {
        global.emitter.emit("displayArticleEditPopup", {
          browserEvent: browserEvent,
          article: article,
        });
      }
    };
  }

  async componentDidMount() {
    if (getConsent() === true) {
      InitializeHotjar();
    }
  }

  render() {
    return (
      <>
        <Router>
          <LocationWatcher />
          <div className={"app"}>
            <header className={"app-header-wrapper"}>
              <Header />
            </header>
            <div className={"app-content-wrapper"}>
              <div className={"centerer-wrapper"}>
                <div className={"centerer"}>
                  <Menu />
                  <Routes>
                    <Route index path={"/home"} element={<HomePage />} />
                    <Route
                      path={`${URL_REDIRECT.categorie}:categoryName`}
                      element={<CategoryPage />}
                    />
                    <Route
                      path={"/c/:category"}
                      element={<CategoryRedirect />}
                    />
                    <Route
                      path={`${URL_REDIRECT.categorie}:categoryName/:subcategoryName`}
                      element={<SubCategoryPage />}
                    />
                    <Route
                      path={"/sc/:subcategory"}
                      element={<SubCategoryRedirect />}
                    />
                    <Route
                      path={`${URL_REDIRECT.categorie}:categoryName/:subcategoryName/:undersubcategoryName`}
                      element={<UnderSubCategoryPage />}
                    />
                    <Route
                      path={"/usc/:undersubcategory"}
                      element={<UnderSubCategoryRedirect />}
                    />
                    <Route
                      path={"/:c/:sc/:usc/:article"}
                      element={<ArticlePage />}
                    />
                    <Route
                      path={"/a/:articleId"}
                      element={<ArticleRedirect />}
                    />

                    <Route path={"/terms"} element={<TermsPage />} />
                    <Route path={"/mentions-legales"} element={<LegalNoticePage />} />
                    <Route path={"/about"} element={<AboutPage />} />
                    <Route path={"/cart"} element={<CartPage />} />
                    <Route
                      path={"/cart/validate"}
                      element={<CartValidatePage />}
                    />

                    <Route
                      path={"/login"}
                      exact={true}
                      element={<LoginPage />}
                    />
                    <Route
                      path={"/credentials/recover/:recoverToken/:userId"}
                      element={<RecoverPasswordPage />}
                    />

                    <Route path={"/admin"} element={<AdministrationMenuPage />}>
                      <Route path={"quotes"}>
                        <Route
                          path={"pending"}
                          element={<QuotesPendingPage />}
                        />
                        <Route
                          path={"ongoing"}
                          element={<QuotesOpenedPage />}
                        />
                        <Route
                          path={"archived"}
                          element={<QuotesHistoryPage />}
                        />
                      </Route>
                      <Route
                        path={"sales/campaigns"}
                        element={<SalesCampaignsPage />}
                      />
                      <Route
                        path={"users/management"}
                        element={<UsersManagementPage />}
                      />
                      <Route
                        path={"home/catalogs"}
                        element={<HomeCatalogsPage />}
                      />
                      <Route path={"oxygene"} element={<OxygenePage />} />
                    </Route>
                    <Route path={"/my/account"} element={<MyAccountPage />}>
                      <Route path={"infos"} element={<AccountInfoPage />} />
                      <Route path={"quotes"} element={<MyQuotesPage />} />
                    </Route>
                    <Route
                      index
                      path={"/contact/us"}
                      element={<ContactUsPage />}
                    />
                    <Route
                      path={"/"}
                      element={<Navigate replace to={"/home"} />}
                    />
                    <Route path={"/404"} element={<NotFoundPage />} />
                    <Route path={"*"} element={<NotFoundPage />} />
                  </Routes>
                </div>
              </div>
            </div>
            <footer className={"app-footer-wrapper"}>
              <Footerr />
            </footer>
            <SnackBar />
            <ArticleEditPopup />
            <ScrollTop />
            <CookieConsentBanner />
          </div>
        </Router>
      </>
    );
  }
}
